export default "__VITE_ASSET__TTb5pooW__"